<app-expansion-panel class="mt-12" i18n-title title="Logs">
  @if (hasLogs) {
    @for (group of groupedLogs; track group.flowId) {
      <app-task-log-table
        [logsList]="group.rows"
        class="d-block mt-12"
        [class.mb-2]="groupedLogs.length > 1"
        (entryClicked)="onEntryClicked(group.elements, $event)"
      />
    }
  } @else {
    <div class="mt-16 text-muted text-center" i18n>Aucun log à afficher</div>
  }
</app-expansion-panel>

<app-task-log-diff-modal
  [diffData]="selectedDiffData"
  (closed)="closeDiffModal()"
/>
<app-task-log-cancellation-changes-modal />
